import randomColor from 'randomcolor'

export default function(str) {
  return randomColor({
    seed: str
  })
}
